import { colors } from '../../colors';
var pagination = {
  activeColor: colors.dirtBrown,
  defaultColor: colors.metal
};
export default pagination;